.theatre {
  position: relative;
  overflow: hidden;
  background: var(--gb-surface-sunken);
  border: var(--gb-rule-width) solid var(--gb-rule);
  display: flex;
  flex-direction: column;
  min-height: clamp(18rem, 46vh, 30rem);
}

.theatreArt {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.4;
  transform-origin: 50% 45%;
  animation: gb-theatre-push var(--gb-camera-push) var(--gb-ease-out) forwards;
}

@keyframes gb-theatre-push {
  from {
    transform: scale(1);
  }
  to {
    transform: scale(1.07);
  }
}

.theatreInner {
  position: relative;
  z-index: 1;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  gap: var(--gb-space-4);
  padding: var(--gb-space-8);
  box-sizing: border-box;
}

.theatreShare {
  font-family: var(--gb-font-mono);
  font-variant-numeric: tabular-nums;
  font-feature-settings: 'tnum' 1;
  font-weight: 700;
  font-size: clamp(3rem, 12vw, 8rem);
  line-height: 0.86;
  letter-spacing: -0.05em;
  margin: 0;
}

.theatreFacts {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: var(--gb-space-2) var(--gb-space-6);
}

.theatreFacts li {
  font-family: var(--gb-font-mono);
  font-variant-numeric: tabular-nums;
  font-feature-settings: 'tnum' 1;
  font-size: var(--gb-data-label);
  letter-spacing: var(--gb-tracking-data);
  text-transform: uppercase;
  color: var(--gb-text-muted);
}

.theatreStrip {
  display: flex;
  align-items: stretch;
  gap: 2px;
  height: 0.75rem;
  width: 100%;
}

.theatreStrip i {
  flex: 1;
  background-color: var(--gb-rule);
  transition: background-color var(--gb-motion-fast) var(--gb-ease);
}

.theatreStrip i[data-filled='true'] {
  background-color: var(--gb-accent);
}

.theatre[data-finished='true'] .theatreStrip i[data-filled='true'] {
  background-color: var(--gb-signal-live);
}

.theatreActions {
  display: flex;
  gap: var(--gb-space-3);
  flex-wrap: wrap;
}

@media (prefers-reduced-motion: reduce) {
  .theatreArt {
    animation: none;
    transform: none;
  }

  .theatreStrip i {
    transition: none;
  }
}
